export const HISTORY_RELATIVE_DATE_TRESHOLD = 2;
export const HISTORY_WIDGET_PAGE_SIZE = 5;
export const HISTORY_LIST_PAGE_SIZE = 10;

export const DAY_SPLIT_CHUNK = 31;
export const DEFAULT_SPLIT_CHUNK = 12;
